import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import Paper from "@material-ui/core/Paper";
import { Button, Tooltip } from "@mui/material";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
// import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import ReportIcon from "@mui/icons-material/Report";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

// const useStyles = makeStyles({
//   root: {
//     width: "100%",
//     overflowX: "auto",
//   },
//   table: {
//     minWidth: 650,
//   },
// });

function createData(
  fieldName,
  oneD,
  twoD,
  ocr,
  dataAlign,
  detail,
  oneDetail,
  twoDetail,
  ocrDetail,
  data,
  oneData,
  twoData,
  ocrData
) {
  return {
    fieldName,
    oneD,
    twoD,
    ocr,
    dataAlign,
    detail,
    oneDetail,
    twoDetail,
    ocrDetail,
    data,
    oneData,
    twoData,
    ocrData,
  };
}
const ExpandableTableRow = ({
  children,
  expandComponent,
  expandComponent1,
  ...otherProps
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        <TableCell padding="checkbox">
          <Button
            variant="text-inline"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? (
              <fuel-icon name={"keyboard_arrow_up"} />
            ) : (
              <fuel-icon name={"keyboard_arrow_down"} />
            )}
          </Button>
        </TableCell>
        {children}
      </TableRow>
      {isExpanded && (
        <>
          <TableRow>
            <TableCell
              padding="checkbox"
              style={{ backgroundColor: "#f7f7f7" }}
            />
            {expandComponent}
          </TableRow>
          <TableRow>
            <TableCell
              padding="checkbox"
              style={{ backgroundColor: "#f7f7f7" }}
            />
            {expandComponent1}
          </TableRow>
        </>
      )}
    </>
  );
};



const norm = (v) => (typeof v === "string" ? v.trim() : (v ?? ""));
const exists = (v) => norm(v) !== "";
const makeCell = (value) => ({
  Results: exists(value) ? "succesicon" : "ERR",
  Data: exists(value) ? norm(value) : "--",
});

const makeField = (one, two) => ({
  oneD: makeCell(one),
  twoD: makeCell(two),
  ocr: makeCell(""),
  dataAlignment: { status: exists(one) && exists(two) ? "succesicon" : "ERR" },
});
const buildMatrixFromReading = (reading) => {
  const one = reading?.lpn_1d_structure || {};
  const two = reading?.lpn_2d_structure || {};
  return {
    BatchNumber: makeField(one.BATCH_NUMBER, two.BATCH_NUMBER),
    CountryofOrigin: makeField(one.COUNTRY_ORIGIN, two.COUNTRY_ORIGIN),
    CustomerRouting: makeField(
      one.CUSTOMER_ROUTING_INFO,
      two.CUSTOMER_ROUTING_INFO
    ),
    DeerePartNumber: makeField(one.DEERE_PART_NBR, two.DEERE_PART_NBR),
    DeliveryNote: makeField(one.DELIVERY_NOTE, two.DELIVERY_NOTE),
    "EngineeringChange/HardwareRev/SoftwareRev": makeField(one.ENGINEERING_CHANGE, two.ENGINEERING_CHANGE),
    Gross: makeField(one.GROSS, two.GROSS),
    KanbanID: makeField(one.KANBAN_ID, two.KANBAN_ID),
    LicensePlateNumber: makeField(one.LPN, two.LPN),
    Net: makeField(one.NET, two.NET),
    PackagingType: makeField(
      one.PACKAGING_TYPE ?? one.CONTAINER_TYPE,
      two.PACKAGING_TYPE ?? two.CONTAINER_TYPE
    ),
    "Plant/UnloadingPoint/InternalDestination": makeField(
      one.INTERNAL_DESTINATION, 
      two.INTERNAL_DESTINATION 
    ),
    Quantity: makeField(one.QTY, two.QTY),
    "SA(ScheduleAgreement)": makeField(one.SA, two.SA),
    ShipFrom: makeField(one.SHIP_FROM, two.SHIP_FROM),
    ShipTo: makeField(one.SHIP_TO, two.SHIP_TO),
    ShipmentDate: makeField(one.SHIPMENT_DATE, two.SHIPMENT_DATE),
    SupplierArea: makeField(one.SUPPLIER_AREA, two.SUPPLIER_AREA),
    SupplierNumber: makeField(one.SUPPLIER_NBR, two.SUPPLIER_NBR),
    UnloadingPoint: makeField(one.UNLOADING_POINT, two.UNLOADING_POINT),
  };
};




export default function UpdatedMatrix(props) {
  const { errors } = props;

  const hasBackendMatrix = errors?.updatedMatrix && typeof errors.updatedMatrix === "object" && Object.keys(errors.updatedMatrix).length > 0;
  const resMatrix = hasBackendMatrix ? errors.updatedMatrix : buildMatrixFromReading(errors);


  //const resMatrix = errors.updatedMatrix;
  const greenicon = (
    <>
      <CheckCircleIcon color="success" />
      Compliant
    </>
  );
  const redicon = (
    <>
      <ReportIcon sx={{ color: "#c21020" }} />
      Not Compliant
    </>
  );

  const rows = [
    createData(
      "Batch Number",
      resMatrix.BatchNumber.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.BatchNumber.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.BatchNumber.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.BatchNumber.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.BatchNumber.oneD["Requirement Guidelines"],
      resMatrix.BatchNumber.twoD["Requirement Guidelines"],
      resMatrix.BatchNumber.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.BatchNumber.oneD.hasOwnProperty("Data")
        ? resMatrix.BatchNumber.oneD.Data
        : "--",
      resMatrix.BatchNumber.twoD.hasOwnProperty("Data")
        ? resMatrix.BatchNumber.twoD.Data
        : "--",
      resMatrix.BatchNumber.ocr.hasOwnProperty("Data")
        ? resMatrix.BatchNumber.ocr.Data
        : "--"
    ),
    createData(
      "Country Of Origin",
      resMatrix.CountryofOrigin.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CountryofOrigin.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CountryofOrigin.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CountryofOrigin.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.CountryofOrigin.oneD["Requirement Guidelines"],
      resMatrix.CountryofOrigin.twoD["Requirement Guidelines"],
      resMatrix.CountryofOrigin.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.CountryofOrigin.oneD.hasOwnProperty("Data")
        ? resMatrix.CountryofOrigin.oneD.Data
        : "--",
      resMatrix.CountryofOrigin.twoD.hasOwnProperty("Data")
        ? resMatrix.CountryofOrigin.twoD.Data
        : "--",
      resMatrix.CountryofOrigin.ocr.hasOwnProperty("Data")
        ? resMatrix.CountryofOrigin.ocr.Data
        : "--"
    ),
    createData(
      "Customer Routing",
      resMatrix.CustomerRouting.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CustomerRouting.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CustomerRouting.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.CustomerRouting.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.CustomerRouting.oneD["Requirement Guidelines"],
      resMatrix.CustomerRouting.twoD["Requirement Guidelines"],
      resMatrix.CustomerRouting.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.CustomerRouting.oneD.hasOwnProperty("Data")
        ? resMatrix.CustomerRouting.oneD.Data
        : "--",
      resMatrix.CustomerRouting.twoD.hasOwnProperty("Data")
        ? resMatrix.CustomerRouting.twoD.Data
        : "--",
      resMatrix.CustomerRouting.ocr.hasOwnProperty("Data")
        ? resMatrix.CustomerRouting.ocr.Data
        : "--"
    ),
    createData(
      "Deere Part Number",
      resMatrix.DeerePartNumber.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.DeerePartNumber.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.DeerePartNumber.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.DeerePartNumber.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.DeerePartNumber.oneD["Requirement Guidelines"],
      resMatrix.DeerePartNumber.twoD["Requirement Guidelines"],
      resMatrix.DeerePartNumber.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.DeerePartNumber.oneD.hasOwnProperty("Data")
        ? resMatrix.DeerePartNumber.oneD.Data
        : "--",
      resMatrix.DeerePartNumber.twoD.hasOwnProperty("Data")
        ? resMatrix.DeerePartNumber.twoD.Data
        : "--",
      resMatrix.DeerePartNumber.ocr.hasOwnProperty("Data")
        ? resMatrix.DeerePartNumber.ocr.Data
        : "--"
    ),
    createData(
      "Delivery Note",
      resMatrix.DeliveryNote.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.DeliveryNote.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.DeliveryNote.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.DeliveryNote.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.DeliveryNote.oneD["Requirement Guidelines"],
      resMatrix.DeliveryNote.twoD["Requirement Guidelines"],
      resMatrix.DeliveryNote.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.DeliveryNote.oneD.hasOwnProperty("Data")
        ? resMatrix.DeliveryNote.oneD.Data
        : "--",
      resMatrix.DeliveryNote.twoD.hasOwnProperty("Data")
        ? resMatrix.DeliveryNote.twoD.Data
        : "--",
      resMatrix.DeliveryNote.ocr.hasOwnProperty("Data")
        ? resMatrix.DeliveryNote.ocr.Data
        : "--"
    ),
    createData(
      "Engineering Change/HardwareRev/SoftwareRev",
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].oneD.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].twoD.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].ocr.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].dataAlignment
        .status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].oneD[
        "Requirement Guidelines"
      ],
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].twoD[
        "Requirement Guidelines"
      ],
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].ocr[
        "Requirement Guidelines"
      ],
      "Data",
      resMatrix[
        "EngineeringChange/HardwareRev/SoftwareRev"
      ].oneD.hasOwnProperty("Data")
        ? resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].oneD.Data
        : "--",
      resMatrix[
        "EngineeringChange/HardwareRev/SoftwareRev"
      ].twoD.hasOwnProperty("Data")
        ? resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].twoD.Data
        : "--",
      resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].ocr.hasOwnProperty(
        "Data"
      )
        ? resMatrix["EngineeringChange/HardwareRev/SoftwareRev"].ocr.Data
        : "--"
    ),
    createData(
      "Gross",
      resMatrix.Gross.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Gross.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Gross.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Gross.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.Gross.oneD["Requirement Guidelines"],
      resMatrix.Gross.twoD["Requirement Guidelines"],
      resMatrix.Gross.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.Gross.oneD.hasOwnProperty("Data")
        ? resMatrix.Gross.oneD.Data
        : "--",
      resMatrix.Gross.twoD.hasOwnProperty("Data")
        ? resMatrix.Gross.twoD.Datas
        : "--",
      resMatrix.Gross.ocr.hasOwnProperty("Data")
        ? resMatrix.Gross.ocr.Data
        : "--"
    ),
    createData(
      "Kanban ID",
      resMatrix.KanbanID.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.KanbanID.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.KanbanID.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.KanbanID.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.KanbanID.oneD["Requirement Guidelines"],
      resMatrix.KanbanID.twoD["Requirement Guidelines"],
      resMatrix.KanbanID.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.KanbanID.oneD.hasOwnProperty("Data")
        ? resMatrix.KanbanID.oneD.Data
        : "--",
      resMatrix.KanbanID.twoD.hasOwnProperty("Data")
        ? resMatrix.KanbanID.twoD.Data
        : "--",
      resMatrix.KanbanID.ocr.hasOwnProperty("Data")
        ? resMatrix.KanbanID.ocr.Data
        : "--"
    ),
    createData(
      "License Plate Number",
      resMatrix.LicensePlateNumber.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.LicensePlateNumber.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.LicensePlateNumber.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.LicensePlateNumber.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.LicensePlateNumber.oneD["Requirement Guidelines"],
      resMatrix.LicensePlateNumber.twoD["Requirement Guidelines"],
      resMatrix.LicensePlateNumber.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.LicensePlateNumber.oneD.hasOwnProperty("Data")
        ? resMatrix.LicensePlateNumber.oneD.Data
        : "--",
      resMatrix.LicensePlateNumber.twoD.hasOwnProperty("Data")
        ? resMatrix.LicensePlateNumber.twoD.Data
        : "--",
      resMatrix.LicensePlateNumber.ocr.hasOwnProperty("Data")
        ? resMatrix.LicensePlateNumber.ocr.Data
        : "--"
    ),
    createData(
      "Net",
      resMatrix.Net.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Net.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Net.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Net.dataAlignment.status === "succesicon" ? greenicon : redicon,
      "Requirement Guidelines",
      resMatrix.Net.oneD["Requirement Guidelines"],
      resMatrix.Net.twoD["Requirement Guidelines"],
      resMatrix.Net.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.Net.oneD.hasOwnProperty("Data")
        ? resMatrix.Net.oneD.Data
        : "--",
      resMatrix.Net.twoD.hasOwnProperty("Data")
        ? resMatrix.Net.twoD.Data
        : "--",
      resMatrix.Net.ocr.hasOwnProperty("Data") ? resMatrix.Net.ocr.Data : "--"
    ),
    createData(
      "Packaging Type",
      resMatrix.PackagingType.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.PackagingType.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.PackagingType.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.PackagingType.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.PackagingType.oneD["Requirement Guidelines"],
      resMatrix.PackagingType.twoD["Requirement Guidelines"],
      resMatrix.PackagingType.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.PackagingType.oneD.hasOwnProperty("Data")
        ? resMatrix.PackagingType.oneD.Data
        : "--",
      resMatrix.PackagingType.twoD.hasOwnProperty("Data")
        ? resMatrix.PackagingType.twoD.Data
        : "--",
      resMatrix.PackagingType.ocr.hasOwnProperty("Data")
        ? resMatrix.PackagingType.ocr.Data
        : "--"
    ),
    createData(
      "Plant/UnloadingPoint/InternalDestination",
      resMatrix["Plant/UnloadingPoint/InternalDestination"].oneD.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["Plant/UnloadingPoint/InternalDestination"].twoD.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["Plant/UnloadingPoint/InternalDestination"].ocr.Results ===
        "succesicon"
        ? greenicon
        : redicon,
      resMatrix["Plant/UnloadingPoint/InternalDestination"].dataAlignment
        .status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix["Plant/UnloadingPoint/InternalDestination"].oneD[
        "Requirement Guidelines"
      ],
      resMatrix["Plant/UnloadingPoint/InternalDestination"].twoD[
        "Requirement Guidelines"
      ],
      resMatrix["Plant/UnloadingPoint/InternalDestination"].ocr[
        "Requirement Guidelines"
      ],
      "Data",
      resMatrix["Plant/UnloadingPoint/InternalDestination"].oneD.hasOwnProperty(
        "Data"
      )
        ? resMatrix["Plant/UnloadingPoint/InternalDestination"].oneD.Data
        : "--",
      resMatrix["Plant/UnloadingPoint/InternalDestination"].twoD.hasOwnProperty(
        "Data"
      )
        ? resMatrix["Plant/UnloadingPoint/InternalDestination"].twoD.Data
        : "--",
      resMatrix["Plant/UnloadingPoint/InternalDestination"].ocr.hasOwnProperty(
        "Data"
      )
        ? resMatrix["Plant/UnloadingPoint/InternalDestination"].ocr.Data
        : "--"
    ),
    createData(
      "Quantity",
      resMatrix.Quantity.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Quantity.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Quantity.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.Quantity.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.Quantity.oneD["Requirement Guidelines"],
      resMatrix.Quantity.twoD["Requirement Guidelines"],
      resMatrix.Quantity.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.Quantity.oneD.hasOwnProperty("Data")
        ? resMatrix.Quantity.oneD.Data
        : "--",
      resMatrix.Quantity.twoD.hasOwnProperty("Data")
        ? resMatrix.Quantity.twoD.Data
        : "--",
      resMatrix.Quantity.ocr.hasOwnProperty("Data")
        ? resMatrix.Quantity.ocr.Data
        : "--"
    ),
    createData(
      "SA(Schedule Agreement)",
      resMatrix["SA(ScheduleAgreement)"].oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix["SA(ScheduleAgreement)"].twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix["SA(ScheduleAgreement)"].ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix["SA(ScheduleAgreement)"].dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix["SA(ScheduleAgreement)"].oneD["Requirement Guidelines"],
      resMatrix["SA(ScheduleAgreement)"].twoD["Requirement Guidelines"],
      resMatrix["SA(ScheduleAgreement)"].ocr["Requirement Guidelines"],
      "Data",
      resMatrix["SA(ScheduleAgreement)"].oneD.hasOwnProperty("Data")
        ? resMatrix["SA(ScheduleAgreement)"].oneD.Data
        : "--",
      resMatrix["SA(ScheduleAgreement)"].twoD.hasOwnProperty("Data")
        ? resMatrix["SA(ScheduleAgreement)"].twoD.Data
        : "--",
      resMatrix["SA(ScheduleAgreement)"].ocr.hasOwnProperty("Data")
        ? resMatrix["SA(ScheduleAgreement)"].ocr.Data
        : "--"
    ),

    createData(
      "Ship From",
      resMatrix.ShipFrom.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipFrom.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipFrom.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipFrom.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.ShipFrom.oneD["Requirement Guidelines"],
      resMatrix.ShipFrom.twoD["Requirement Guidelines"],
      resMatrix.ShipFrom.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.ShipFrom.oneD.hasOwnProperty("Data")
        ? resMatrix.ShipFrom.oneD.Data
        : "--",
      resMatrix.ShipFrom.twoD.hasOwnProperty("Data")
        ? resMatrix.ShipFrom.twoD.Data
        : "--",
      resMatrix.ShipFrom.ocr.hasOwnProperty("Data")
        ? resMatrix.ShipFrom.ocr.Data
        : "--"
    ),
    createData(
      "Ship To",
      resMatrix.ShipTo.oneD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipTo.twoD.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipTo.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipTo.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.ShipTo.oneD["Requirement Guidelines"],
      resMatrix.ShipTo.twoD["Requirement Guidelines"],
      resMatrix.ShipTo.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.ShipTo.oneD.hasOwnProperty("Data")
        ? resMatrix.ShipTo.oneD.Data
        : "--",
      resMatrix.ShipTo.twoD.hasOwnProperty("Data")
        ? resMatrix.ShipTo.twoD.Data
        : "--",
      resMatrix.ShipTo.ocr.hasOwnProperty("Data")
        ? resMatrix.ShipTo.ocr.Data
        : "--"
    ),
    createData(
      "Shipment Date",
      resMatrix.ShipmentDate.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.ShipmentDate.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.ShipmentDate.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.ShipmentDate.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.ShipmentDate.oneD["Requirement Guidelines"],
      resMatrix.ShipmentDate.twoD["Requirement Guidelines"],
      resMatrix.ShipmentDate.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.ShipmentDate.oneD.hasOwnProperty("Data")
        ? resMatrix.ShipmentDate.oneD.Data
        : "--",
      resMatrix.ShipmentDate.twoD.hasOwnProperty("Data")
        ? resMatrix.ShipmentDate.twoD.Data
        : "--",
      resMatrix.ShipmentDate.ocr.hasOwnProperty("Data")
        ? resMatrix.ShipmentDate.ocr.Data
        : "--"
    ),
    createData(
      "Supplier Area",
      resMatrix.SupplierArea.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.SupplierArea.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.SupplierArea.ocr.Results === "succesicon" ? greenicon : redicon,
      resMatrix.SupplierArea.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.SupplierArea.oneD["Requirement Guidelines"],
      resMatrix.SupplierArea.twoD["Requirement Guidelines"],
      resMatrix.SupplierArea.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.SupplierArea.oneD.hasOwnProperty("Data")
        ? resMatrix.SupplierArea.oneD.Data
        : "--",
      resMatrix.SupplierArea.twoD.hasOwnProperty("Data")
        ? resMatrix.SupplierArea.twoD.Data
        : "--",
      resMatrix.SupplierArea.ocr.hasOwnProperty("Data")
        ? resMatrix.SupplierArea.ocr.Data
        : "--"
    ),
    createData(
      "Supplier Number",
      resMatrix.SupplierNumber.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.SupplierNumber.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.SupplierNumber.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.SupplierNumber.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.SupplierNumber.oneD["Requirement Guidelines"],
      resMatrix.SupplierNumber.twoD["Requirement Guidelines"],
      resMatrix.SupplierNumber.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.SupplierNumber.oneD.hasOwnProperty("Data")
        ? resMatrix.SupplierNumber.oneD.Data
        : "--",
      resMatrix.SupplierNumber.twoD.hasOwnProperty("Data")
        ? resMatrix.SupplierNumber.twoD.Data
        : "--",
      resMatrix.SupplierNumber.ocr.hasOwnProperty("Data")
        ? resMatrix.SupplierNumber.ocr.Data
        : "--"
    ),
    createData(
      "Unloading point",
      resMatrix.UnloadingPoint.oneD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.UnloadingPoint.twoD.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.UnloadingPoint.ocr.Results === "succesicon"
        ? greenicon
        : redicon,
      resMatrix.UnloadingPoint.dataAlignment.status === "succesicon"
        ? greenicon
        : redicon,
      "Requirement Guidelines",
      resMatrix.UnloadingPoint.oneD["Requirement Guidelines"],
      resMatrix.UnloadingPoint.twoD["Requirement Guidelines"],
      resMatrix.UnloadingPoint.ocr["Requirement Guidelines"],
      "Data",
      resMatrix.UnloadingPoint.oneD.hasOwnProperty("Data")
        ? resMatrix.UnloadingPoint.oneD.Data
        : "--",
      resMatrix.UnloadingPoint.twoD.hasOwnProperty("Data")
        ? resMatrix.UnloadingPoint.twoD.Data
        : "--",
      resMatrix.UnloadingPoint.ocr.hasOwnProperty("Data")
        ? resMatrix.UnloadingPoint.ocr.Data
        : "--"
    ),
  ];

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <Table style={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" />
            <TableCell style={{ fontWeight: "bold" }}>Field Name</TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              1D
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              2D
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              OCR
            </TableCell>
            <TableCell style={{ fontWeight: "bold" }} align="right">
              Data Alignment &nbsp;
              <Tooltip title="1D, 2D & OCR all have the same data.">
                <InfoOutlined style={{ fontSize: "1rem" }} />
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <ExpandableTableRow
              key={row.detail}
              expandComponent={
                <>
                  {" "}
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      fontSize: "12px",
                      backgroundColor: "#f7f7f7",
                    }}
                  >
                    {row.detail}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.oneDetail}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.twoDetail}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.ocrDetail}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  ></TableCell>
                </>
              }
              expandComponent1={
                <>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      fontSize: "12px",
                      backgroundColor: "#f7f7f7",
                    }}
                  >
                    {row.data}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.oneData}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.twoData}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  >
                    {row.ocrData}
                  </TableCell>
                  <TableCell
                    align="right"
                    style={{ fontSize: "12px", backgroundColor: "#f7f7f7" }}
                  ></TableCell>
                </>
              }
            >
              <TableCell
                component="th"
                scope="row"
                style={{ fontWeight: "bold" }}
              >
                {row.fieldName}
              </TableCell>
              <TableCell align="right">{row.oneD}</TableCell>
              <TableCell align="right">{row.twoD}</TableCell>
              <TableCell align="right">{row.ocr}</TableCell>
              <TableCell align="right">{row.dataAlign} &nbsp;</TableCell>
            </ExpandableTableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
